import { AppsData } from '../typings/mobile-apps';

export const UPDATE_APPS_DATA = 'UPDATE_APPS_DATA';
export type UPDATE_APPS_DATA = typeof UPDATE_APPS_DATA;

export interface UpdateAppsData {
    type: UPDATE_APPS_DATA;
    gridData: AppsData;
}

export function updateAppsData(gridData: AppsData): UpdateAppsData {
    return {
        type: UPDATE_APPS_DATA,
        gridData: gridData
    };
}

export const FETCH_APPS_DATA = 'FETCH_APPS_DATA';
export type FETCH_APPS_DATA = typeof FETCH_APPS_DATA;

export interface FetchAppsData {
    type: FETCH_APPS_DATA;
    login: string;
}

export function fetchAppsData(login: string): FetchAppsData {
    return {
        type: FETCH_APPS_DATA,
        login
    };
}

export const UPDATE_TOOLTIP_ELEMENT_ID = 'UPDATE_TOOLTIP_ELEMENT_ID';
export type UPDATE_TOOLTIP_ELEMENT_ID = typeof UPDATE_TOOLTIP_ELEMENT_ID;

export type MobileAppsListAction = FetchAppsData | UpdateAppsData;
